// Native variant-selects continues to own prices, availability, URL and cart IDs.
// Only update thumbnails when another option (e.g. colour) changes.
if (!window.splinVariantThumbnails) {
  window.splinVariantThumbnails = true;
  document.addEventListener('change', event => {
    const picker = event.target.closest('variant-selects');
    if (!picker?.querySelector('.splin-variant-options')) return;
    const variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent);
    const groups = [...picker.querySelectorAll('.splin-variant-options')];
    const selected = groups.map(group => group.querySelector('input:checked')?.value);
    for (const [index, group] of groups.entries()) {
      for (const input of group.querySelectorAll('input[type="radio"]')) {
        const candidates = variants.filter(variant => variant.options[index] === input.value && variant.featured_image);
        candidates.sort((a, b) => {
          const score = variant => variant.options.reduce((total, value, i) => total + (i !== index && value === selected[i] ? 1 : 0), 0);
          return score(b) - score(a);
        });
        const image = input.nextElementSibling.querySelector('img');
        if (!image || !candidates.length) continue;
        const url = new URL(candidates[0].featured_image.src, location.origin);
        url.searchParams.set('width', '240');
        image.removeAttribute('srcset');
        image.src = url.toString();
      }
    }
  });
}
